import type { Address } from '$types/address';
import type { User } from '$types/user';
import { SharedState } from '$utils/sharedState.svelte';
import { TrustStatus } from '$types/trustStatus';
import { VerificationBadgeType } from '$types/verificationBadge';
import type { Trusts } from '$types/trusts';

export class StateTrusts extends SharedState<Trusts> {
  public getCombined(): User[] {
    if (!this.current) return [];

    return [...this.current.received, ...this.current.givenOrMutual];
  }

  public givenOrMutualAddresses(): Address[] {
    if (!this.current) return [];

    return this.current.givenOrMutual.map((entry) => entry.address);
  }

  public receivedOrMutualTrusts(): User[] {
    if (!this.current) return [];

    return [...this.current.received, ...this.current.givenOrMutual].filter(
      (entry) => entry.trust === TrustStatus.INCOMING || entry.trust === TrustStatus.MUTUAL,
    );
  }

  public receivedBackersTrusts(): User[] {
    if (!this.current) return [];

    return [...this.current.received, ...this.current.givenOrMutual].filter(
      (entry) =>
        (entry.trust === TrustStatus.INCOMING || entry.trust === TrustStatus.MUTUAL) &&
        entry.verificationBadge === VerificationBadgeType.VERIFIED,
    );
  }

  public hasReceivedOneTrust(): boolean {
    if (!this.current) {
      return false;
    }

    return this.current?.receivedCount >= 1;
  }
}

export const stateTrusts = new StateTrusts(null);
